<div class="searchForm flex-row" >
  <fieldset class="border p-2">
    <legend class="w-auto">Configuration</legend>
    <div class="flex-row">
      <div class="form-row">
        <div class="col-md-6 col-6">
          <label  for="text" >Label :</label> &nbsp;
          <span class="badge badge-info">{{config?.label}}</span>
        </div>
        <div class="col-md-6 col-6">
            <label  for="text" >Satatus :</label> &nbsp;
            <span *ngIf="config?.active" class="badge badge-secondary">Active</span>
                <span *ngIf="!config?.active" class="badge badge-secondary">Inactive</span>
          </div>

      </div>
    </div>
  </fieldset>
  <fieldset class="border p-2">
    <legend class="w-auto">Places</legend>
    <div class="d-flex p-2 flex-row-reverse" >
      <div class="col-2">
        <ng-container>
        <button type="button" (click)="addPlaces()"
        class="btn btn-indigo btn-sm btn-block"
        style= "margin-left: 0px;margin-right: 0px;width: 100%;min-width: none;"
        >Ajouter</button>
      </ng-container>
      </div>
    </div>
    <div class="cardList" fxlayoutgap="5px grid">
    <ng-template ngFor let-place [ngForOf]="configPlaces" let-i="index" >
      <app-config-place [place]="place" (deleteEvent)="deletePlace(place)" fxFlex="1 1 auto"></app-config-place>
    </ng-template>
    </div>
</fieldset>
<div class="form-row justify-content-center">
  <div class=" col-2">
    <button type="button" (click)="save()"
    style= "margin-left: 0px;margin-right: 0px;width: 100%;min-width: none;"
    class="btn btn-sm btn-secondary"
          [routerLink]="['/configurations']">Annuler</button>
</div>
<div class=" col-2">
      <button type="button" (click)="save()"
      class="btn btn-indigo btn-sm btn-block"
      style= "margin-left: 0px;margin-right: 0px;width: 100%;min-width: none;"
      >Valider</button>
  </div>
</div>
